<template>
    <v-container fluid class="container-full-bg-gray">
        <v-snackbar
            v-if="remittance_list_component"
            v-model="remittance_list_component.snackbar.isVisible"
            :color="remittance_list_component.snackbar.color"
            :timeout="remittance_list_component.snackbar.timeout"
        >
            {{ remittance_list_component.snackbar.text }}
        </v-snackbar>
        <v-dialog persistent max-width="500" v-model="remittance_list_component.unremit_dialog" v-if="remittance_list_component.unremit_dialog">
            <v-card>
                <v-card-title>
                    <span class="primary_blue--text">Desremesar</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <p class="text-subtitle-1 mt-4">
                        Se restaurará el estado pendiente de pago de  {{ remittance_list_component.selected_remittance.invoices_count }} factura(s)
                    </p>
                    <p>
                        Ids facturas: {{ remittance_list_component.selected_remittance.invoices }}
                    </p>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="remittance_list_component.unremit_dialog=false; remittance_list_component.selected_remittance=null;" class="action__btn">Cancelar</v-btn>
                    <v-btn 
                        color="primary_blue"
                        class="white--text action__btn"
                        @click="unremit()"
                    >
                    Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent max-width="500" v-model="remittance_list_component.mark_as_paid_dialog" v-if="remittance_list_component.mark_as_paid_dialog">
            <v-card>
                <v-card-title>
                    <span class="primary_blue--text">Marcar como pagada</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <p class="text-subtitle-1 mt-4">
                        Se marcarán como pagadas  {{ remittance_list_component.selected_remittance.invoices_count }} factura(s)
                    </p>
                    <p>
                        Ids facturas: {{ remittance_list_component.selected_remittance.invoices }}
                    </p>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="remittance_list_component.mark_as_paid_dialog=false; remittance_list_component.selected_remittance=null;" class="action__btn">Cancelar</v-btn>
                    <v-btn 
                        color="primary_blue"
                        class="white--text action__btn"
                        @click="mark_as_paid()"
                    >
                    Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="remittance_list_component.deleteDialog"
            max-width="600"
            persistent
        >
            <v-card>
                <v-card-title class="title-dialog">
                    <span class="primary_blue--text">Eliminar remesas</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <p class="text-subtitle-1 mt-4">
                        Se restaurará el estado pendiente de pago de las siguientes facturas:
                    </p>
                    <p v-for="item in remittance_list_component.selectedItems" :key="item.uuid">
                        
                        <span>
                            <b>Id: {{ item.uuid }} ({{roundValue(item.totalAmount)}}€) - {{ item.invoices_count }} factura(s)</b>
                            <br>
                            <ul>
                                <li>
                                    Ids facturas: {{ item.invoices }}
                                </li>
                            </ul>
                        </span>
                    </p>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="remittance_list_component.deleteDialog=false;" class="action__btn">Cancelar</v-btn>
                    <v-btn 
                        color="primary_blue"
                        class="white--text action__btn"
                        @click="deleteItems()"
                    >
                    Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <app-row>
            <app-col cols="12">
                <v-card width="100%" class="rounded-10">
                    <v-card-title class="primary--text text--darken-2 px-5 pb-0 d-flex card-title-footer-color">
                        <span> 
                            <v-btn v-if="companydb_id" icon @click="$router.push({name: 'invoice-list', params: {'companydb_id': companydb_id}})">
                                <AppIcon :src="require('../assets/back-arrow.svg')" :size="20" :preserveColors="true"/>
                            </v-btn>
                            <span class="primary_blue--text ml-4">Remesas</span>  
                        </span>
                        <v-row class="pa-0 ma-0">
                            <v-col cols="3" class="pa-0 ma-0"> </v-col>
                            <v-col cols="9" class="pa-0 ma-0">
                                <slot name="search_right">
                                    <div align="right">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn @click="refreshList()" color="primary_blue" icon v-bind="attrs" v-on="on"
                                                    :loading="remittance_list_component.loading">
                                                    <v-icon>mdi-refresh</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Actualizar</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn @click="previweDeleteItems()" color="primary_blue" icon v-bind="attrs" v-on="on"
                                                    :loading="remittance_list_component.loadingDeleteProduct" :disabled="remittance_list_component.selectedItems.length==0">
                                                    <v-icon>mdi-delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </div>
                                </slot>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="px-0 pt-0 card-title-footer-color">
                        <v-data-table 
                            :items="remittance_list_component.remittances"
                            :headers="remittance_list_component.remittance_headers"
                            :loading="remittance_list_component.loading"
                            v-model="remittance_list_component.selectedItems"
                            :show-select="remittance_list_component.showSelect"
                            fixed-header
                            @update:items-per-page="changeLimit"           
                            @update:page="changeOffset" 
                            item-key="uuid"
                            >
                            <!-- Header Personalizables -->
                            <template v-for="header in remittance_list_component.remittance_headers" v-slot:[`header.${header.value}`]="{ header }">
                                <span tabindex="0">
                                    {{ header.text }}
                                </span>
                            </template>

                            <!-- Columnas Personalizables -->
                            <template v-for="header in remittance_list_component.remittance_headers" v-slot:[`item.${header.value}`]="{ item }">
                                <span class="font-color">
                                    <slot v-if="header.value == 'state'" :name="header.value" v-bind="item">
                                        {{ stateTranslator(item[header.value]) }}
                                    </slot>
                                    <slot v-else-if="header.value == 'totalAmount'" :name="header.value" v-bind="item">
                                        {{ roundValue(item[header.value]) }} €
                                    </slot>
                                    <slot v-else>
                                        {{ item[header.value] }}
                                    </slot>
                                </span>
                            </template>
                            <!-- <template v-if="screen_data.hideHeaderCheckbox" #header.data-table-select></template> -->
                            
                            <template v-slot:item.actions="{ item }">
                                <div class="d-flex align-center" style="gap: 1rem;">
                                
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <div 
                                                @click="remittance_list_component.downloadRemittance(item.uuid)"
                                                v-bind="attrs"
                                                v-on="on"
                                                color="primary"
                                                >
                                                <AppIcon :src="require('../assets/bank-download-transactions.svg')" :size="20" :colorMap="{ 'var(--v-primary_blue-base)': 'primary_blue' }"/>
                                            </div>
                                        </template>
                                        <span>Descargar XML</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn 
                                                @click="unremit_pop_up(item)"
                                                v-bind="attrs"
                                                v-on="on"
                                                color="primary_blue"
                                                icon
                                                :disabled="item.state == 'pending'"
                                                >
                                                <v-icon>mdi-undo-variant</v-icon>
                                            </v-btn >
                                        </template>
                                        <span>Desremesar facturas</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn 
                                                @click="mark_as_paid_pop_up(item)"
                                                v-bind="attrs"
                                                v-on="on"
                                                color="primary_blue"
                                                icon
                                                :disabled="item.state == 'paid'"
                                                >
                                                <v-icon>mdi-playlist-check</v-icon>
                                            </v-btn >
                                        </template>
                                        <span>Marcar facturas como pagadas</span>
                                    </v-tooltip>
                                </div>
                            </template>

                            <!--Footer: Paginación-->
                            <template v-slot:[`footer.page-text`]="items">
                                {{ items.pageStart }} - {{ items.pageStop }} de
                                {{ items.itemsLength }}
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </app-col>
        </app-row>
    </v-container>
</template>

<script>
import { ApiRemittanceRepository } from "../modules/facturae/infra/ApiRemittanceRepository";
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue'
import AppBtn from "@/components/layout/AppBtn.vue";
import AppRow from "@/components/layout/AppRow.vue";
import AppCol from "@/components/layout/AppCol.vue";
import AppTextField from "@/components/layout/AppTextField.vue";
import AppAutocomplete from "@/components/layout/AppAutocomplete.vue";
import { RemittanceListComponent } from "@/modules/facturae/app/RemittanceListComponent";
import AppSearchBar from '@/components/layout/AppSearchBar.vue';

export default {
    name: "RemittanceList",
    components: {
        AppTextField,
        AppBtn,
        AppCol,
        AppRow,
        AppConfirmModal,
        AppAutocomplete,
        AppSearchBar
    },
    data() {
        let remittance_repo = new ApiRemittanceRepository();
        const remittance_list_component = new RemittanceListComponent(remittance_repo)
        return {
            remittance_list_component:remittance_list_component,
        };
    },
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
        },
    },
    watch: { 
        companydb_id: function() {
            this.$router.push({ 'name': 'product-list', 'params': { 'companydb_id': this.companydb_id }})
            this.refreshList()
        }
    },
    async mounted() {
        // let remittance_repo = new ApiRemittanceRepository();
        // this.remittance_list_component = new RemittanceListComponent(remittance_repo)
        this.remittance_list_component.updateRemittanceList(this.companydb_id, {})
    },
    methods: {
        stateTranslator(state) {
            const fieldMap = {
                'pending': 'Pendiente',
                'paid': 'Pagada',
            };

            return fieldMap[state] || state;
        },
        roundValue(value) {
            return parseFloat(value).toFixed(2);
        },
        refreshList() {
            this.remittance_list_component.updateRemittanceList(this.companydb_id, {})
        },
        changeLimit(limit) {
            this.remittance_list_component.limit = limit
        },
        changeOffset(offset) {
            this.remittance_list_component.offset = offset
        },
        unremit_pop_up(item){
            console.log(item)
            this.remittance_list_component.selected_remittance = item
            this.remittance_list_component.unremit_dialog = true
        },
        mark_as_paid_pop_up(item){
            console.log(item)
            this.remittance_list_component.selected_remittance = item
            this.remittance_list_component.mark_as_paid_dialog = true
        },
        async unremit(){
            this.remittance_list_component.unremit_selected()
        },
        async mark_as_paid(){
            this.remittance_list_component.mark_as_paid_selected()
        },
        previweDeleteItems() {
            this.remittance_list_component.previewDeleteDialog()
        },
        async deleteItems() {
            await this.remittance_list_component.deleteRemittances()
        }
    },
    computed:{
        currentPage(){
                return Math.trunc(this.offset/this.limit)+1
        },
    }
};
</script>

<style scoped>

::v-deep .v-card__title {
    padding-top: 15px !important;
    padding-bottom: 15px !important;

}
.card-title-footer-color {
    background: #fafaff;
}

::v-deep .v-data-footer {
    background-color: #fafaff;
    margin-right: 0px !important;
    padding-right: 17px;
}

::v-deep .v-data-table-header>tr>th {
    background-color: var(--v-primaryLight-base) !important;
}

::v-deep .v-data-table-header>tr>th>span,
::v-deep .v-data-table-header>tr>th>div>div>div>label>span {
    color: var(--v-primary-base);
    font-size: 0.875rem;
}

.font-color {
    color: #56565b;
}

::v-deep .v-data-table__wrapper>table>tbody>tr>td {
    border-bottom: none !important;
}

::v-deep tbody tr:nth-of-type(even) {
    /* 'deep-orange lighten-5' basides on material design color */
    background-color: rgba(245, 245, 245, 0.47);
}

::v-deep .v-input__prepend-inner>div>i {
    color: var(--v-primary-base);
    top: 2px;
    padding-left: 5px;
}

.text-field-size {
    font-weight: normal;
    font-size: 0.875rem;
}

::v-deep .input-search .v-input__slot::before {
    border-style: none !important;
}

::v-deep .input-search .v-text-field__slot,
::v-deep .input-search .v-input__prepend-inner,
::v-deep .input-search .v-input__slot {
    background-color: #f2f1ff !important;
}

::v-card-title .title-dialog {
    justify-content: space-around;
}

.autocomplete_field {
    border: solid 1px;
    border-color: var(--v-primary-base);
    color: transparent !important;
    height: 50px !important;
    margin: 0;
    padding: 0;
}

.acction_btns {
    display: flex !important;
    justify-content: space-between !important;
    padding: 0 36px 20px;
}

.action__btn {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    border-radius: 20px;
    padding: 18px !important;
    gap: 8px;
    text-transform: capitalize;
}


.cancel_button {
    border: 1px solid var(--v-primary-base);
    background-color: white !important;
    color: var(--v-primary-base);
    padding: 20px !important;
    font-size: 20px;
    text-transform: none !important;
}

.accept_button {
    border: 1px solid var(--v-primary-base);
    background-color: var(--v-primary-base) !important;
    color: white;
    padding: 20px !important;
    font-size: 20px;
    text-transform: none !important;
}

.btn-right {
    display: flex;
    justify-content: flex-end;
}

.no-underline>>>.v-text-field .v-input__control>.v-input__slot:before {
    border: none;
}
.rounded-10 {
    border-radius: 10px !important;
}

.primary_blue--text {
    color: var(--v-primary_blue-base) !important;
    font-size: 20px;
    font-weight: 500;
}
</style>